import { Link, useParams } from 'react-router-dom';
import { JournalHistoryComponent } from './JournalHistoryComponent';

/** A chat thread's History, from the journal: every turn on it, end to end (admin only). */
export function ChatThreadHistoryPage(): JSX.Element {
  const { threadId } = useParams<{ threadId: string }>();
  if (!threadId) return <div className="container"><div className="alert alert-error">No thread named.</div></div>;
  return (
    <div className="container">
      <p><Link to="/admin/chat/analytics">← Chat analytics</Link> · <Link to={`/apps/chat/${threadId}`}>Open the chat</Link></p>
      <h1>Chat history</h1>
      <p>What the journal recorded for this thread: each turn opening and ending, every workflow and activity attempt, each tool and outbound call.</p>
      <JournalHistoryComponent about={{ threadId }} />
    </div>
  );
}
